import React, { useState, useEffect } from 'react';

function CSVColumnMapper({ headers, onNext, onCancel, file }) {
    const [mapping, setMapping] = useState({
        date: '',
        player: '',
        payment: ''
    });
    const [previewData, setPreviewData] = useState([]);

    useEffect(() => {
        // Read first few lines of the CSV for preview
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const text = e.target.result;
                const lines = text.split('\n');
                const preview = lines.slice(0, 4).map(line => line.split(','));
                setPreviewData(preview);
            };
            reader.readAsText(file);
        }
    }, [file]);

    const handleMappingChange = (field, columnName) => {
        setMapping(prev => ({
            ...prev,
            [field]: columnName
        }));
    };

    const handleSubmit = () => {
        // Validate all required fields are mapped
        if (!mapping.date || !mapping.player || !mapping.payment) {
            alert('Please map all required columns');
            return;
        }
        onNext(mapping);
    };

    const getColumnIndex = (headerName) => {
        return headers.indexOf(headerName);
    };

    return (
        <div className="csv-mapper">
            <h4>Map CSV Columns</h4>
            
            {/* CSV Preview Table */}
            <div className="csv-preview">
                <h5>CSV Preview</h5>
                <div className="preview-table">
                    <table>
                        <thead>
                            <tr>
                                {headers.map((header, index) => (
                                    <th key={index} className={`
                                        ${mapping.date === header ? 'mapped-date' : ''}
                                        ${mapping.player === header ? 'mapped-player' : ''}
                                        ${mapping.payment === header ? 'mapped-payment' : ''}
                                    `}>
                                        {header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {previewData.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    {headers.map((_, colIndex) => (
                                        <td key={colIndex}>
                                            {row[colIndex]}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="mapping-grid">
                <div className="mapping-row">
                    <label>Date Column:</label>
                    <select 
                        value={mapping.date} 
                        onChange={(e) => handleMappingChange('date', e.target.value)}
                    >
                        <option value="">Select Date Column</option>
                        {headers.map(header => (
                            <option key={header} value={header}>{header}</option>
                        ))}
                    </select>
                    {mapping.date && (
                        <div className="column-preview">
                            Example: {previewData[1]?.[getColumnIndex(mapping.date)]}
                        </div>
                    )}
                </div>
                <div className="mapping-row">
                    <label>Player Reference Column:</label>
                    <select 
                        value={mapping.player} 
                        onChange={(e) => handleMappingChange('player', e.target.value)}
                    >
                        <option value="">Select Player Column</option>
                        {headers.map(header => (
                            <option key={header} value={header}>{header}</option>
                        ))}
                    </select>
                    {mapping.player && (
                        <div className="column-preview">
                            Example: {previewData[1]?.[getColumnIndex(mapping.player)]}
                        </div>
                    )}
                </div>
                <div className="mapping-row">
                    <label>Payment Amount Column:</label>
                    <select 
                        value={mapping.payment} 
                        onChange={(e) => handleMappingChange('payment', e.target.value)}
                    >
                        <option value="">Select Payment Column</option>
                        {headers.map(header => (
                            <option key={header} value={header}>{header}</option>
                        ))}
                    </select>
                    {mapping.payment && (
                        <div className="column-preview">
                            Example: {previewData[1]?.[getColumnIndex(mapping.payment)]}
                        </div>
                    )}
                </div>
            </div>
            <div className="mapping-actions">
                <button onClick={onCancel} className="cancel-button">Cancel</button>
                <button onClick={handleSubmit} className="next-button">Next</button>
            </div>
        </div>
    );
}

export default CSVColumnMapper; 